import { render, staticRenderFns } from "./BulkImports.vue?vue&type=template&id=4704624f&scoped=true"
import script from "./BulkImports.vue?vue&type=script&lang=js"
export * from "./BulkImports.vue?vue&type=script&lang=js"
import style0 from "./BulkImports.vue?vue&type=style&index=0&id=4704624f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4704624f",
  null
  
)

export default component.exports